import type { ButtonProps } from "antd";

import { StyledFloatingActionButton } from "./Styled";

interface FloatingActionButtonProps extends ButtonProps {
    top?: number;
    right?: number;
    left?: number;
    bottom?: number;
    position?: "absolute" | "fixed";
    btnSize?: number;
    zIndex?: number;
    bgColor?: "success" | "error";
    iconSize?: number;
}

export const FloatingActionButton = ({
    top,
    right,
    left,
    bottom,
    position = "absolute",
    btnSize = 50,
    zIndex = 0,
    bgColor = "success",
    iconSize = 28,
    ...props
}: FloatingActionButtonProps) => {
    return (
        <StyledFloatingActionButton
            $top={top}
            $bottom={bottom}
            $right={right}
            $left={left}
            $size={btnSize}
            $zIndex={zIndex}
            $position={position}
            $bgColor={bgColor}
            $iconSize={iconSize}
            type={"primary"}
            {...props}
        />
    );
};
